<template>
  <div class="content">
    <div class="list">
      <div class="item" @click="pikerType">
        <span class="item-title">服务类别</span>
        <span class="item-content city">{{agent.type_name}}</span>
        <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
      </div>
      <div class="item"  @click="changeCity">
        <span class="item-title">服务城市</span>
        <span v-if="!city" class="item-content">请选择您的服务城市</span>
        <span v-if="city" class="item-content city">{{city}}</span>
        <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
      </div>
      <div class="item">
        <span class="item-title">联系人</span>
        <input type="text" class="input" v-model="agent.agentName" placeholder="请输入您的姓名">
      </div>
      <div class="item">
        <span class="item-title">手机号</span>
        <input type="tel" maxlength="11" class="input" v-model="agent.agentMobile" placeholder="请输入手机号">
      </div>
      <div class="item" v-if="agent.type === 1">
        <span class="item-title">公司名称</span>
        <input type="text" class="input" v-model="agent.agentCompanyName" placeholder="请输入公司名称">
      </div>
      <div class="item">
        <span class="item-title">银行账号</span>
        <input type="text" class="input" v-model="agent.agentBankAccount" placeholder="请输入公司的银行账号">
      </div>
      <div class="item">
        <span class="item-title">开户行</span>
        <input type="text" class="input" v-model="agent.agentBank" placeholder="请输入开户行信息">
      </div>
      <div class="upload-img" v-if="agent.type === 1">
        <div class="" >
          <span class="upload-title">请拍摄并上传营业执照</span><span class="upload-hint">*请确保上传的图片清晰度</span>
        </div>
        <label for="image" class="label">
          <img v-if="!imageUrl" :src="publicImg + '/Business_license@3x.png'" alt="">
          <img v-if="imageUrl" :src="agent.imageUrl" alt="">
          <span>点击上传营业执照</span>
        </label>
        <input class="input" id="image" type="file" accept="image/*" @change="checkField">
      </div>
    </div>
    <div class="submit">
      <button v-if="agent.type === 2" @click="submit" :class="agent.proId && agent.agentName && agent.agentMobile && agent.agentBankAccount && agent.agentBank ? '' : 'devices'">提交认证</button>
      <button v-if="agent.type === 1" @click="submit" :class="agent.agentCompanyName && agent.proId && agent.agentName && agent.agentMobile && agent.agentBankAccount && agent.agentBank && agent.imageUrl ? '' : 'devices'">提交认证</button>
      <!-- <span>提交认证即代表同意<i @click="toCooperation">《服务商合作协议》</i></span> -->
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
    <div class="piker" v-if="piker" @click="pikerType">
      <div class="piker-item">
        <div :class="agent.type == 1 ? 'select' : ''" @click.stop="selectType(0)">企业</div>
        <div :class="agent.type == 2 ? 'select' : ''" @click.stop="selectType(1)">个人</div>
      </div>
    </div>
  </div>
</template>
<script>
import dialogItem from '@/components/dialog'
import { uploadImage, addAgent } from '@/http/api'
import lrz from 'lrz'

export default {
  data () {
    return {
      publicImg: 'http://picture.eclicks.cn/kaojiazhao/public/rem',
      public_path: process.env.PUBLICK_PATH,
      showDialog: false,
      city: '',
      imageUrl: '',
      massage: '213',
      piker: false,
      agent: localStorage.agent ? JSON.parse(localStorage.agent) : {imageUrl: '', type: 1, type_name: '企业'},
      agent_type: [{
        type: 1,
        name: '企业'
      }, {
        type: 2,
        name: '个人'
      }]
    }
  },
  components: {
    'dialog-item': dialogItem
  },
  methods: {
    toCooperation () {
      this.$router.push({
        path: '/cooperationPact'
      })
    },
    checkField (e) {
      console.log(e)
      let token = localStorage.token
      let file = e.target.files[0]
      lrz(file, {
        width: 300
      }).then(rst => {
        rst.formData.append('token', token)
        uploadImage(rst.formData).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.agent.imageUrl = res.data.up
            this.imageUrl = res.data.up
            console.log(this.imageUrl)
            localStorage.setItem('agent', JSON.stringify(this.agent))
          }
        })
      })
    },

    changeCity () {
      this.$router.push({
        path: '/cities'
      })
    },

    pikerType () {
      if (this.piker) {
        this.piker = false
      } else {
        this.piker = true
      }
    },

    selectType (index) {
      this.agent = {
        type: this.agent_type[index].type,
        type_name: this.agent_type[index].name,
        agentMobile: localStorage.mobile
      }
      this.imageUrl = ''
      this.city = ''
      this.piker = false
    },

    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },

    submit () {
      let agent = this.agent
      if (!agent.proId) {
        this.showDia('请选择服务城市')
      } else if (!agent.agentName) {
        this.showDia('请填写联系人姓名')
      } else if (!agent.agentMobile) {
        this.showDia('请填写联系人手机号')
      } else if (!agent.agentBankAccount) {
        this.showDia('请填写银行卡号')
      } else if (!agent.agentBank) {
        this.showDia('请填写开户行')
      } else {
        console.log(agent)
        let data = {
          type: agent.type,
          token: localStorage.token, // token
          province_id: agent.proId, // 省id
          city_id: agent.cityId, // 市id
          mobile: agent.agentMobile, // 手机号
          contact: agent.agentName, // 联系人
          bank_name: agent.agentBank, // 银行名称
          bank_card: agent.agentBankAccount, // 银行卡号
          cp_name: agent.agentCompanyName, // 公司名称
          cp_business_license: agent.imageUrl // 营业执照
        }
        console.log(data)
        addAgent(data).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$router.push({
              path: '/checking'
            })
          } else {
            this.showDia(res.msg)
          }
        })
      }
    }
  },

  beforeDestroy () {
    console.log(this.agent)
    localStorage.setItem('agent', JSON.stringify(this.agent))
  },

  mounted () {
    let mobile = localStorage.mobile
    let pickCity = localStorage.pickCity
    if (pickCity) {
      pickCity = JSON.parse(pickCity)
      let city = pickCity.cityName.join('-')
      this.agent.proId = pickCity.cityid[0]
      this.agent.cityId = pickCity.cityid[1]
      this.city = city
      localStorage.setItem('agent', JSON.stringify(this.agent))
    }
    if (this.agent.imageUrl) {
      this.imageUrl = this.agent.imageUrl
    }
    this.agent.agentMobile = mobile
  }
}
</script>
<style lang="scss" scoped>

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgba(51, 51, 51, .5);
}
input:-moz-placeholder, textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(51, 51, 51, .5);
}
input::-moz-placeholder, textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(51, 51, 51, .5);
}
input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(51, 51, 51, .5);
}

.content {
  font-size: 0;
  color: #333;
  // background: #f5f5f5;
}
.list {
  width: 100%;
  padding: 0 .3rem;
  box-sizing: border-box;
  background: #fff;
  .item {
    height: 1.3rem;
    width: 100%;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    img {
      width: .14rem;
      height: .25rem;
    }
    .item-title {
      font-size: .3rem;
      display: inline-block;
      width: 1.47rem;
      margin-right: .5rem;
      font-weight: 600;
      text-align-last: justify;
    }
    > input {
      font-size: .28rem;
      width: 4.93rem;
      background: #fff;
      border: none;
    }
    .item-content {
      font-size: .28rem;
      width: 4.93rem;
      color: rgba(51, 51, 51, .5);
    }
    .city {
      color: #333;
    }
  }
  .upload-img {
    line-height: 1.3rem;
    >div {
      display: flex;
    }
    .upload-title {
      font-size: .3rem;
      font-weight: 600;
      flex: 1;
    }
    .upload-hint {
      font-size: .24rem;
      color: rgba(51, 51, 51, 0.5);
      text-align: right;
      flex: 1;
    }
    .label {
      display: block;
      margin: auto;
      text-align: center;
      img {
        display: block;
        width: 6.3rem;
        height: 3rem;
        margin: auto;
      }
      span {
        margin-top: .24rem;
        font-size: .26rem;
        color: rgba(2, 179, 137, 1);
      }
    }
    .input {
      display: none;
    }
  }
}
.submit {
  margin-top: .37rem;
  text-align: center;
  padding-bottom: .4rem;
  button {
    font-size: .32rem;
    color: #fff;
    display: block;
    margin: auto;
    width: 6.90rem;
    height: .90rem;
    background: rgba(2, 179, 137, 1);
    border-radius: .45rem;
    margin-bottom: .4rem;
  }
  .devices {
    background: #d4d4d4;
  }
  span {
    font-size: .24rem;
    color: rgba(51, 51, 51, 0.5);
    i {
      color: #02B389;
      font-style:normal;
    }
  }
}
.dialog-item {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.piker {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  .piker-item {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    div {
      text-align: center;
      font-size: .3rem;
      height: 1rem;
      line-height: 1rem;
      background: #fff;
      margin-top: .1rem;
    }
    .select {
      color: #02B389;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/apply/Apply.vue